<template>
  <tr class="children-text-right" @click="$emit('click')">
    <td class="text-left d-flex items-center">
      <slot />
    </td>
    <td>{{ hb && hb.id }}</td>
    <td v-html="getIndicators(hb)" class="text-left" />
    <td>{{ decHex(hb && hb.originalLastPointer) }}</td>
    <td>{{ brNum(hb && hb.summary && hb.summary.rawDataLength) }}</td>
    <td>{{ decHex(hb && hb.summary && hb.summary.endPointer) }}</td>
    <td>{{ hb && hb.receivedOn | moment('YYYY-MM-DD HH:mm:ss Z', '─') }}</td>
  </tr>
</template>

<script>
import _ from 'lodash'
import brush from 'brush'
import { brNum } from 'oderon-commons/src/formatters'

function decHex(x) {
  if (x == null) return '─'
  return `${brNum(x)} <code>0x${brush.toHexString(x)}</code>`
}

function hasGps(hb) {
  if (hb == null) return false
  let flag = _.get(hb, 'summary.hasGps')
  if (flag == false) return false

  if (
    hb.latitude == 0 ||
    hb.longitude == 0 ||
    hb.latitude >= 90 ||
    hb.latitude <= -90 ||
    hb.longitude <= -180 ||
    hb.longitude >= 180
  ) {
    return false
  }

  return true
}

function getIndicators(row) {
  let h = (row && row.summary) || {}
  let result = [
    ['engine', 'on', h.engineOn],
    ['spd', 'on', h.hasSpeed],
    ['rdLen', 'on', h.rawDataLength > 0],
    ['noGps', 'on', !hasGps(row)],
    ['ptrDump', 'on', h.hasDumpedPointer],
    ['ptrCorr', 'on', h.hasPointerCorrection],
    ['skip', 'on', h.skipped],
    ['shutdown', 'on', _.get(h, 'variables.shutdownReason') != null],
    ['drain', 'on', h.drainedOut]
  ].map((i) => {
    let c = i[2] ? i[1] : ''
    return `<span title="${i[0]}" class="${c}">${i[0]}</span>`
  })

  return `<span class="hb-indicators large">${result.join('')}</span>`
}

export default {
  props: {
    hb: { required: true }
  },
  methods: {
    getIndicators,
    decHex,
    brNum(x) {
      if (x == null) return '─'
      return brNum(x)
    }
  }
}
</script>

<style lang="sass">
.hb-indicators
  font-size: 13px
  font-weight: 400

.children-text-right td:not(.text-left),
.children-text-right th:not(.text-left)
  text-align: right !important
</style>

